export default {
    methods: {
        resetObject() {
            this.data = JSON.parse(JSON.stringify(this.rawData));
            this.resetErrors();
        },
        prepareData(data) {
            if (typeof data.amm === 'undefined' || data.amm === null || typeof data.amm.id === 'undefined') {
                data.amm = {};
            }

            return data;
        },
        prepareFormData(data) {
            if (typeof data.amm === 'undefined' || data.amm === null || typeof data.amm.id === 'undefined') {
                data.amm = {};
            }
            return {
                course: {
                    executionNumber: data.execution_number,
                    amm: data.amm.id,
                    startDate: data.start_date,
                    endDate: data.end_date,
                    fullyBooked: data.fully_booked,
                    hiddenInCalendarSubscription: data.hidden_in_calendar_subscription || false,
                    name: data.name,
                    type: data.type,
                    language: data.language,
                },
            };
        },
    },
};
